import { computed, type ComputedRef, ref } from 'vue'
import { type MaybeElementRef, useIntersectionObserver } from '@vueuse/core'

export interface StickyGridFiltersBar {
    gridTopBarWrapperEl: MaybeElementRef
    gridEl: MaybeElementRef
    classGridTopBarWrapper: ComputedRef<Record<string, boolean>>
    gridTopBarHeight: '70px'
}

export function useStickyGridFiltersBar(): StickyGridFiltersBar {
    const gridTopBarWrapperEl: MaybeElementRef = ref(null)
    const gridEl: MaybeElementRef = ref(null)
    const isGridTopBarStuck = ref(false)
    const gridTopBarHeight = '70px' as const

    useIntersectionObserver(
        gridTopBarWrapperEl,
        ([entry]) => {
            if (!entry) {
                return
            }

            isGridTopBarStuck.value = entry.isIntersecting
        },
        {
            root: gridEl,
            rootMargin: `-${gridTopBarHeight} 0px 0px 0px`,
            threshold: 0.1,
        }
    )

    const classGridTopBarWrapper = computed(() => ({
        'stuck': isGridTopBarStuck.value,
    }))

    return {
        gridTopBarWrapperEl,
        gridEl,
        classGridTopBarWrapper,
        gridTopBarHeight,
    }
}
